import styled from 'styled-components/native';
import { View } from 'react-native';
import { FORM_WIDTH_DESKTOP, Size } from 'src/constants';
import { Headline, HoverButton } from 'src/components';

export const ScreenContainer = styled.SafeAreaView`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.primary};
`;

export const ContentContainer = styled(View)`
  flex: 1;
  justify-content: ${({ theme }) => (theme.viewMode.isMobile ? 'flex-start' : 'center')};
  align-items: stretch;
  padding-horizontal: ${({ theme }) => (theme.viewMode.isMobile ? `${Size.X2_S}` : '0px')};
`;

export const FullScreenContainer = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.primary};
  padding-horizontal: ${({ theme }) => (theme.viewMode.isMobile ? `0px` : `${Size.L}px`)};
  padding-top: ${({ theme }) => (theme.viewMode.isMobile ? '0px' : `${Size.S}px`)};
  gap: ${Size.M}px;
`;

export const LogoWrapper = styled.View`
  position: ${({ theme }) => (theme.viewMode.isMobile ? 'relative' : 'absolute')};
  top: ${({ theme }) => (theme.viewMode.isMobile ? '0px' : `${Size.L}px`)};
  left: ${({ theme }) => (theme.viewMode.isMobile ? '0px' : `${Size.L}px`)};
  margin-bottom: ${({ theme }) => (theme.viewMode.isMobile ? Size.M : 0)}px;
  align-items: ${({ theme }) => (theme.viewMode.isMobile ? 'center' : 'flex-start')};
  width: ${({ theme }) => (theme.viewMode.isMobile ? '100%' : 'auto')};
  z-index: 10;
`;

export const StyledHoverButton = styled(HoverButton).attrs(({ theme }) => ({
  labelStyle: { color: theme.colors.onPrimary }
}))`
  padding: ${Size.S}px;
`;

export const Card = styled.View`
  background-color: ${({ theme }) => theme.colors.surface};
  padding: ${Size.X2_S}px;
  ${({ theme }) => !theme.viewMode.isMobile && `width: ${FORM_WIDTH_DESKTOP}px;`}
  ${({ theme }) => !theme.viewMode.isMobile && `align-self: center;`}
  border-radius: ${({ theme }) => theme.roundness};
`;

export const InputContainer = styled.View`
  gap: ${Size.S}px;
`;

export const StyledHeadline = styled(Headline)`
  text-align: center;
  margin-vertical: ${Size.S}px;
`;
